import Controller from '@ember/controller';
import { getOwner } from '@ember/application';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import TransactionalSetupBaseController from './base-controller';
import TransactionalMessageModel from 'cio/models/transactional-message';

export default class TransactionalMessageSetupController extends Controller {
  @service router!: RouterService;

  declare model: TransactionalMessageModel;

  @computed('model.hasDirtyAttributes')
  get isDirty() {
    return this.model.hasDirtyAttributes;
  }

  @computed('model.{contentSource,hasTemplateContent}')
  get navSteps() {
    return [
      {
        path: 'transactional.message.setup.index',
        title: 'Add Content',
        disabled: false,
        validationKey: 'hasTemplateContent',
      },
      {
        path: 'transactional.message.setup.settings',
        title: 'Configure Settings',
        disabled: !this.model.hasTemplateContent,
        validationKey: 'hasAllSettings',
      },
      {
        path: 'transactional.message.setup.review',
        title: 'Send Message',
        disabled: !this.model.hasTemplateContent,
        validationKey: 'hasSentMessage',
      },
    ];
  }

  @computed('router.currentRouteName', 'navSteps.@each.path')
  get currentNavStep() {
    return this.navSteps.find((step) => this.router.isActive(step.path));
  }

  @computed('navSteps.[]', 'currentNavStep')
  get isLastStep() {
    return this.currentNavStep && this.navSteps.indexOf(this.currentNavStep) === this.navSteps.length - 1;
  }

  @computed('currentNavStep')
  get currentNavStepController() {
    if (!this.currentNavStep) {
      return null;
    }

    return getOwner(this).lookup(`controller:${this.currentNavStep.path}`) as TransactionalSetupBaseController;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'transactional-message-setup': TransactionalMessageSetupController;
  }
}
